import { Resume } from '@sr/types';
import { Box } from '../common/ui';
type Props = {
  firstName: string;
  lastName: string;
  resume: Resume;
};

const Monogram = ({ firstName, lastName, resume }: Props) => {
  const { activeTemplateId } = resume.style;
  let monogramStyle = 'rectangle-solid';
  const customizations = resume.style.customizations[activeTemplateId];

  if (customizations && customizations.monogramStyle) {
    const style = customizations.monogramStyle;
    if (style !== undefined) {
      monogramStyle = style;
    }
  }

  switch (monogramStyle) {
    case 'rectangle-solid':
      return (
        <Box
          sx={{
            backgroundColor: 'accent1',
            height: 50,
            width: 40,
            py: '6px',
          }}
        >
          <Character character={firstName.charAt(0)} />
          <Character character={lastName.charAt(0)} />
        </Box>
      );

    case 'rectangle-outline':
      return (
        <Box
          sx={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'accent1',
            height: 50,
            width: 40,
            py: '6px',
          }}
        >
          <Character character={firstName.charAt(0)} />
          <Character character={lastName.charAt(0)} />
        </Box>
      );

    case 'circle-solid':
      return (
        <Box
          sx={{
            backgroundColor: 'accent1',
            height: 50,
            width: 50,
            borderRadius: 999,
            py: '6px',
          }}
        >
          <Character character={firstName.charAt(0)} />
          <Character character={lastName.charAt(0)} />
        </Box>
      );

    case 'circle-outline':
      return (
        <Box
          sx={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'accent1',
            borderRadius: 999,
            height: 50,
            width: 50,
            py: '6px',
          }}
        >
          <Character character={firstName.charAt(0)} />
          <Character character={lastName.charAt(0)} />
        </Box>
      );

    case 'none':
      return null;

    default:
      throw new Error(`Invalid monogramStyle value ${monogramStyle}`);
  }
};

function Character({ character }: { character: string }) {
  return (
    <Box
      sx={{
        fontSize: 14,
        color: 'accent2',
        lineHeight: '19px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontFamily: 'body',
      }}
    >
      {character}
    </Box>
  );
}

export default Monogram;
